export interface ProjectPostRequest {
  projectNumber: string;
  projectName: string;
  clientName: string;
  startDate: string | null;
  endDate: string | null;
  isUnproductive: boolean;
  isDairen: boolean;
}

export const EmptyProjectPostRequest: ProjectPostRequest = {
  projectNumber: '',
  projectName: '',
  clientName: '',
  startDate: null,
  endDate: null,
  isUnproductive: false,
  isDairen: false,
};
